import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge taught about the custom scales in tailwind.config.js, so a
 * consumer's `rounded-12` or `h-ctl-lg` correctly overrides a component's
 * default instead of both classes landing in the DOM.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ['10', '12', '14', '16', '18', '20', '24'],
      spacing: [
        'gutter',
        'gutter-results',
        'gutter-m',
        'nav',
        'nav-m',
        'touch',
        'ctl-chip',
        'ctl-quick',
        'ctl-filter',
        'ctl-sm',
        'ctl-staff',
        'ctl-md',
        'ctl-cta',
        'ctl-input',
        'ctl-lg',
      ],
      shadow: ['hero', 'book-card', 'pin', 'dot'],
    },
    classGroups: {
      // Custom fontSize keys (tailwind.config.js), so `text-display-xl` is a
      // font size and doesn't evict a text colour like `text-sl-ink`.
      'font-size': [{ text: ['display-2xl', 'display-xl', 'display-lg'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
